import { PartnerMarketingPage } from "apps/partnerMarketing/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(PartnerMarketingPage, "PartnerMarketingPage");
